import { render, staticRenderFns } from "./QuestsView.vue?vue&type=template&id=a3f28cb6"
import script from "./QuestsView.vue?vue&type=script&lang=js"
export * from "./QuestsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports